import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/setup/priceBook/initialState.priceSheet.data';
import {
  CHECK_BOX_VALUE,
  PRICING_DATA,
  handlePending,
  handleRejection,
} from '../../../../constants';
import {
  fetchPricesGetData as fetchPricesGetDataAPI,
  fetchAccountingGroupsData as fetchAccountingGroupsAPI,
  fetchCountriesData as fetchCountriesAPI,
  fetchPriceTypesData as fetchPriceTypesAPI,
  accountingGroupSearchData as accountingGroupSearchDataAPI,
  countriesSearchData as countriesSearchDataAPI,
  priceSheetSearchData as priceSheetSearchDataAPI,
  priceSheetGetData as priceSheetGetDataAPI,
  pricesGetData as pricesGetDataAPI,
  priceSheetNotesData as priceSheetNotesDataAPI,
  priceSheetAuditTrailData as priceSheetAuditTrailDataAPI,
  fetchPriceClassServiceOfferings as fetchPriceClassServiceOfferingsAPI,
  priceSheetSaveData as priceSheetSaveDataAPI,
  fetchPriceSheetSearchCount as fetchPriceSheetSearchCountAPI,
  copypriceSheetSaveData as copypriceSheetSaveDataAPI,
} from '../../../../apis/priceBookAPI';
import { ACTIONS_PRICE_SHEET } from '../../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import {
  formatEffectiveDateTime,
  updateObjectInArray,
  evalcalculatedFees,
} from '../../../../utils/common';

// Define an async thunk to fetch data from the API

export const fetchAccountingGroupsData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.FETCH_ACCOUNTING_GROUPS,
  fetchAccountingGroupsAPI
);

export const fetchCountriesData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.FETCH_COUNTRIES,
  fetchCountriesAPI
);

export const fetchPriceTypesData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.FETCH_PRICE_TYPES,
  fetchPriceTypesAPI
);

export const accountingGroupSearchData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.REQUEST_ACCOUNTING_GROUP_SEARCH,
  accountingGroupSearchDataAPI
);

export const countriesSearchData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.FETCH_COUNTRIES_SEARCH,
  countriesSearchDataAPI
);

export const priceSheetSearchData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.REQUEST_PRICESHEET_SEARCH,
  priceSheetSearchDataAPI
);

export const fetchPriceSheetSearchCount = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.REQUEST_PRICESHEET_SEARCH_COUNT,
  fetchPriceSheetSearchCountAPI
);

export const priceSheetGetData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.GET_PRICESHEET_ID,
  priceSheetGetDataAPI
);

export const fetchPricesGetData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.FETCH_PRICES_DATA,
  fetchPricesGetDataAPI
);

export const pricesGetData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.GET_PRICES,
  pricesGetDataAPI
);

export const priceSheetNotesData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.GET_PRICESHEET_NOTES,
  priceSheetNotesDataAPI
);

export const priceSheetAuditTrailData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.GET_PRICESHEET_AUDIT_TRAIL,
  priceSheetAuditTrailDataAPI
);

export const fetchPriceClassServiceOfferings = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.GET_PRICECLASS_SERVICE_OFFERINGS,
  fetchPriceClassServiceOfferingsAPI
);

export const priceSheetSaveData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.REQUEST_PRICESHEET_SAVE,
  priceSheetSaveDataAPI
);

export const copypriceSheetSaveData = createAsyncThunkWrapper(
  ACTIONS_PRICE_SHEET.REQUEST_PRICESHEET_COPY_SAVE,
  copypriceSheetSaveDataAPI
);

let uniqueIdCounter = 0;

const generateUniqueId = () => {
  uniqueIdCounter -= 1;
  return uniqueIdCounter;
};

const priceSheetSlice = createSlice({
  name: 'priceSheet',
  initialState,
  reducers: {
    cleatPriceSheetSelectedData: (state) => {
      state.priceSheetSelectedData = initialState.priceSheetSelectedData;
    },
    setSearchTerm: (state, action) => {
      state.nameContainsSearchTerm = action?.payload;
    },
    setPriceSheetFormFields: (state, action) => {
      state.priceSheetForm[action?.payload?.name] = action?.payload?.value;
    },
    setDeferralAddNotes: (state, action) => {
      state.notesData[action?.payload?.name] = action?.payload?.value;
    },
    setLogisticAddNotes: (state, action) => {
      state.notesData[action?.payload?.name] = action?.payload?.value;
    },
    setLogisticFee: (state, action) => {
      state.logisticFeeData[action?.payload?.name] = action?.payload?.value;
      state.changedPriceSheet.priceSheet[action?.payload?.name] =
        action?.payload?.value;
    },
    handleActiveFlag: (state, action) => {
      state.changedPriceSheet.priceSheet[action?.payload?.name] =
        action?.payload?.value;
    },
    setSelectedCountryGridRowsData: (state, action) => {
      state.gridCountryRowSelectedData = action?.payload ? action?.payload : [];
      state.gridCountryRowSelectedCount = action?.payload?.length;
      const data = action?.payload[0] ? action?.payload[0] : [];
      if (state.openCopyPriceSheetModal === false) {
        state.priceSheetForm.countryId = data?.countryId ? data?.countryId : 0;
        state.priceSheetForm.countryName = data?.name ? data?.name : '';
      } else if (state.openCopyPriceSheetModal === true) {
        state.copypriceSheetForm.countryId = data?.countryId
          ? data.countryId
          : 0;
        state.priceSheetForm.countryName = data?.name ? data.name : '';
        state.dstPriceSheetCountry = data?.name ? data.name : '';
      }
      state.openCountryModal = false;
    },
    setSelectedAccountGridRowsData: (state, action) => {
      state.gridAccountingRowSelectedData = action?.payload
        ? action?.payload
        : [];
      state.gridAccountingRowSelectedCount = action?.payload?.length;
      if (state.openCopyPriceSheetModal === false) {
        state.priceSheetForm.accountingGroup = action?.payload[0]
          ?.accountingGroupCode
          ? action?.payload[0]?.accountingGroupCode.trim()
          : '';
        state.priceSheetForm.accountingName = action?.payload[0]?.name
          ? action?.payload[0]?.name
          : '';
      } else if (state.openCopyPriceSheetModal === true) {
        state.copypriceSheetForm.accountingGroup = action?.payload[0]
          ?.accountingGroupCode
          ? action?.payload[0]?.accountingGroupCode.trim()
          : '';
        state.copypriceSheetForm.accountingName = action?.payload[0]?.name
          ? action?.payload[0]?.name
          : '';
        state.dstPriceSheetAccGrp = action?.payload[0]?.name
          ? action?.payload[0]?.name
          : '';
      }
      state.openAccountingModal = false;
    },
    setAccountingGroupModalOpen: (state) => {
      state.openAccountingModal = true;
      state.accoutingGroupSearchForm.accountGroupName = '';
    },
    setAccountingGroupModalClose: (state) => {
      state.openAccountingModal = false;
      state.accoutingGroupSearchForm.accountGroupName = '';
      state.accoutingGroupSearchForm.isResellerGroup = CHECK_BOX_VALUE.no;
      state.accountingGroupFilteredData = [];
    },
    setOpenCountryModal: (state) => {
      state.openCountryModal = true;
      state.countrySearchForm.name = '';
    },
    setCloseCountryModal: (state) => {
      state.openCountryModal = false;
      state.countrySearchForm.name = '';
      state.countrySearchForm.countryCode = '';
    },
    setOpenAlertBoxCopyExist: (state) => {
      state.alertDialogCopyExist = true;
    },
    setCloseAlertBoxCopyExist: (state) => {
      state.alertDialogCopyExist = false;
    },
    setOpenAlertBox: (state) => {
      state.alertDialog = true;
    },
    setCloseAlertBox: (state) => {
      state.alertDialog = false;
    },
    setOpenAlertBoxDuplicateCountry: (state) => {
      state.alertDialogDuplicateCountry = true;
    },
    setCloseAlertBoxDuplicateCountry: (state) => {
      state.alertDialogDuplicateCountry = false;
    },
    setAccouningGroupFormFeilds: (state, action) => {
      state.accoutingGroupSearchForm[action?.payload?.name] =
        action?.payload?.value;
    },
    setCountryFormFeilds: (state, action) => {
      state.countrySearchForm[action?.payload?.name] = action?.payload?.value;
    },
    handleFilteredCoutryData: (state, action) => {
      state.countrySearchData = action?.payload ? action?.payload : [];
    },
    handleFilteredAccountingGroupData: (state, action) => {
      state.accountingGroupSearchData = action?.payload ? action?.payload : [];
    },
    handleSelectedTab: (state, action) => {
      if (state.isDeferralPriceSheet) {
        state.selectedPreDefTabVal = state.selectededTab;
        state.priceClassSelectBYId = initialState.priceClassSelectBYId;
      }

      if (state.selectedPreLogTabVal) {
        state.selectedPreLogTabVal = state.selectededTab;
        state.priceClassSelectBYId = initialState.priceClassSelectBYId;
      }

      state.selectededTab = action?.payload ? action?.payload : 0;
    },
    handleShowDeferralPriceSheet: (state) => {
      state.isDeferralPriceSheet = true;
      state.isLogisticFeesSheet = false;
    },
    handleShowLogisticPriceSheet: (state) => {
      state.isLogisticFeesSheet = true;
      state.isDeferralPriceSheet = false;
    },
    handleCloseDeferralPriceSheet: (state) => {
      state.isDeferralPriceSheet = false;
    },
    handleCloseLogisticPriceSheet: (state) => {
      state.isLogisticFeesSheet = false;
    },
    handleSelectedDate: (state, action) => {
      if (state.openCopyPriceSheetModal === false) {
        state.priceSheetForm.effectiveDate = action?.payload || null;
      } else if (state.openCopyPriceSheetModal === true) {
        state.copypriceSheetForm.effectiveDate = action?.payload || null;
      }
    },
    handleResetValue: (state) => {
      state.priceSheetForm = initialState.priceSheetForm;
      state.priceSheetSelectedData = initialState.priceSheetSelectedData;
      state.alertText = initialState.alertText;
      state.priceSheetData = initialState.priceSheetData;
      state.priceSheetTotalCount = initialState.priceSheetTotalCount;
      state.isUpdatedDeferralSheet = initialState.isUpdatedDeferralSheet;
      state.isUpdatedLogisticSheet = initialState.isUpdatedLogisticSheet;
      state.saveReason = initialState.saveReason;
    },
    handlePriceSheetAlert: (state, action) => {
      state.alertText = action?.payload
        ? action?.payload
        : PRICING_DATA.errorCommon;
    },
    handleSelectedPrisheetGrid: (state, action) => {
      //we have srcData inside gridAccountingRowSelectedData onclick of viewsheet
      state.gridAccountingRowSelectedData = action?.payload
        ? action?.payload
        : [];

      let data = [];
      if (
        (state.priceSheetForm?.accountingGroup === '' ||
          state.priceSheetForm?.accountingGroup === null) &&
        Array(action?.payload)?.length === 1 &&
        Array(action?.payload)[0]?.length > 0
      ) {
        data =
          action?.payload?.filter(
            (item) => item.accountingGroupName === null
          ) || [];
        if (data?.length > 0) {
          data = data[0];
        } else {
          data = action.payload[0] ? action.payload[0] : [];
        }
      } else {
        data = action.payload[0] ? action.payload[0] : [];
      }

      state.priceSheetSelectedData.priceSheetId = data?.priceSheetId;
      state.priceSheetSelectedData.createdBy = data?.createdBy;
      state.priceSheetSelectedData.createdOn = data?.createdOn;
      state.priceSheetSelectedData.countryId = data?.countryId;
      state.priceSheetSelectedData.accountingGroupCode =
        data?.accountingGroupCode;
      state.priceSheetSelectedData.accountingGroupName =
        data?.accountingGroupName;
      state.priceSheetSelectedData.countryCode = data?.countryCode;

      state.priceSheetSelectedData.countryName = data?.countryName;
      state.priceSheetSelectedData.pricingTypeId = data?.pricingTypeId;
      state.priceSheetSelectedData.pricingType = data?.pricingType;
      state.priceSheetSelectedData.activeFlag = data?.activeFlag;
      state.priceSheetSelectedData.effectiveDate = data?.effectiveDate
        ? new Date(data.effectiveDate)
        : new Date();
      state.srcPriceSheetAccGrp = data?.accountingGroupName;
      state.srcPriceSheetCountry = data?.countryName;
    },
    handlePriceClassSearch: (state, action) => {
      state.priceClassSearch[action?.payload?.name] = action?.payload?.value;
    },
    handleServiceOfferingSearch: (state, action) => {
      state.searchServiceOffer[action?.payload?.name] = action?.payload?.value;
    },
    handleResetPriceClassForm: (state) => {
      state.priceClassSearch.priceClassName = '';
    },
    handleResetServiceForm: (state) => {
      state.searchServiceOffer.name = '';
    },
    handleModalOpen: (state) => {
      state.isModalOpen = true;
    },
    handleModalClose: (state) => {
      state.isModalOpen = false;
      state.notesSelectedGridData = [];
      let ele = document.querySelectorAll(
        '.notesGridPriceSheet .MuiDataGrid-row'
      );
      ele.forEach((item) => {
        item.classList.remove('Mui-selected');
        item.classList.add('non-selected');
      });
    },
    handleNotesSlectedGrid: (state, action) => {
      state.notesSelectedGridData = action?.payload ? action?.payload : [];
      const data = action?.payload[0] ? action?.payload[0] : [];
      state.notesData.comment = data?.comment || '';
    },
    handleEditNotesData: (state) => {
      const data = state.notesSelectedGridData[0]
        ? state.notesSelectedGridData[0]
        : [];
      const selectedPricingNoteId = data?.pricing_Note_Id;
      // Find the note in the array with the matching pricing_Note_Id
      const foundNote = state.changedPriceSheet?.notes?.find(
        (note) => note?.pricing_Note_Id === selectedPricingNoteId
      );
      if (foundNote) {
        // If the note with the given pricing_Note_Id is found in the array
        foundNote.comment = state.notesData?.comment || '';
      }

      if (state.isDeferralPriceSheet) {
        state.isUpdatedDeferralSheet = true;
      }

      if (state.isLogisticFeesSheet) {
        state.isUpdatedDeferralSheet = true;
      }
    },
    handleResetNotes: (state) => {
      state.notesData.comment = '';
      state.isEditNotes = false;
    },
    handleAddNewNotes: (state) => {
      state.notesData.comment = '';
      state.isEditNotes = false;
      state.isEditClick = false;
    },
    handleAddNewNotesSave: (state, action) => {
      state.notesData.pricing_Id = state.priceSheetDataById?.pricing_Id;
      state.notesData.pricing_Note_Id = generateUniqueId();
      //User Details to be updated after User implementation completed
      state.notesData.userId = action?.payload?.userId;
      state.notesData.userFirstName = action?.payload?.userFirstName;
      state.notesData.userLastName = action?.payload?.userLastName;
      state.notesData.lastModifiedUserId = action?.payload?.userId;
      state.changedPriceSheet.notes.push({
        ...state.notesData,
      });
      if (state.isDeferralPriceSheet) {
        state.isUpdatedDeferralSheet = true;
      }

      if (state.isLogisticFeesSheet) {
        state.isUpdatedLogisticSheet = true;
      }
    },
    handlePriceClassSelectedGrid: (state, action) => {
      state.priceClassSearchGrid = action?.payload ? action?.payload : [];
    },

    handlePriceClassAdd: (state) => {
      const data = state.priceClassSearchGrid[0]
        ? state.priceClassSearchGrid[0]
        : [];
      const pricingId =
        state.priceSheetSelectedData.priceSheetId !== 0
          ? state.priceSheetDataById?.pricing_Id
          : -1;
      const mappedPriceClasses = {
        pricing_Id: pricingId,
        priceClassId: data?.price_Class_Id,
        priceClassName: data?.name,
        lastModifiedUserId: data?.last_Modified_User_Id,
        lastModifiedTimestamp: data?.last_Modified_TimeStamp,
      };
      if (state.duplicatePriceSheetObj === undefined) {
        state.duplicatePriceSheetObj = [];
      }
      if (state.changedPriceSheet.priceClasses === undefined) {
        state.changedPriceSheet.priceClasses = [];
      }

      const duplicateArr = state.duplicatePriceSheetObj || [];
      const isDuplicate = duplicateArr.some(
        (existingPriceClass) =>
          existingPriceClass.priceClassId === mappedPriceClasses.priceClassId
      );
      if (!isDuplicate) {
        // If it's not a duplicate, then add it
        let addedPriceClassData = [
          mappedPriceClasses,
          ...state.duplicatePriceSheetObj,
        ];

        state.duplicatePriceSheetObj = addedPriceClassData;
        state.changedPriceSheet.priceClasses.push(mappedPriceClasses);
        state.priceClassesTotalCount += 1;
        state.isDuplicatePriceClasses = false;
      } else {
        state.isDuplicatePriceClasses = true;
      }

      if (state.isDeferralPriceSheet) {
        state.isUpdatedDeferralSheet = true;
      }

      if (state.isLogisticFeesSheet) {
        state.isUpdatedLogisticSheet = true;
      }
    },
    handleDeletePriceClasses: (state, action) => {
      state.changedPriceSheet.priceClasses = action?.payload
        ? action?.payload
        : [];
      state.priceClassesTotalCount -= 1;
    },
    handlePriceClassSelectById: (state, action) => {
      state.priceClassSelectBYId = action?.payload ? action?.payload : [];
    },
    handleSelectedServiceOfferGrid: (state, action) => {
      state.serviceOfferingSearchGrid = action?.payload ? action?.payload : [];
    },
    handleServiceOfferingAdd: (state) => {
      const data = state.serviceOfferingSearchGrid[0]
        ? state.serviceOfferingSearchGrid[0]
        : [];
      const mappedServiceOfferings = {
        servicePriceLevelId: data?.service_Price_Level_Id,
        servicePriceLevelName: data?.name,
        annualFee: 0,
        calculatedFees: 0,
        firstModifiedTimestamp: new Date(),
        lastModifiedUserId: data?.last_Modified_User_Id,
        lastModifiedTimestamp: data?.last_Modified_TimeStamp,
        servicePriceLevelDesc: data?.description,
      };

      const selectedRowIndex = state.isClickedRowIndex
        ? state.isClickedRowIndex
        : 0;

      // Checking for duplicates in duplicateArr
      const duplicateArr = state.duplicatePriceSheetObj || [];
      const isDuplicateInDuplicateArr = duplicateArr.some((item, index) => {
        if (index === selectedRowIndex) {
          return item.serviceOfferings?.some(
            (service) =>
              service.servicePriceLevelName ===
              mappedServiceOfferings.servicePriceLevelName
          );
        }
        return false;
      });

      // Checking for duplicates in serviceOfferingsArr
      const serviceOfferingsArr =
        state.changedPriceSheet.serviceOfferings || [];
      const isDuplicateInServiceOfferingsArr = serviceOfferingsArr.some(
        (item, index) => {
          if (index === selectedRowIndex) {
            return item.serviceOfferings?.some(
              (service) =>
                service.servicePriceLevelName ===
                mappedServiceOfferings.servicePriceLevelName
            );
          }
          return false;
        }
      );

      if (!isDuplicateInDuplicateArr && !isDuplicateInServiceOfferingsArr) {
        // If it's not a duplicate in either array, add to both
        state.isDuplicateServiceOfferings = false;
        let uncutObj = {};
        const duplicateArrUpdated = duplicateArr?.map((item, index) => {
          if (index === selectedRowIndex) {
            uncutObj = {
              pricingId: item.pricing_Id,
              priceClassId: item.priceClassId,
              priceClassName: item.priceClassName,
            };
            const updatedServiceOfferings = [
              {
                ...mappedServiceOfferings,
                ...uncutObj,
              },
              ...(item.serviceOfferings || []),
            ];

            return {
              ...item,
              serviceOfferings: updatedServiceOfferings,
            };
          }
          return item;
        });
        const serviceOfferingsArrUpdated = [
          {
            ...mappedServiceOfferings,
            ...uncutObj,
          },
          ...serviceOfferingsArr,
        ];

        // Update the state with the modified arrays
        state.duplicatePriceSheetObj = duplicateArrUpdated;
        state.changedPriceSheet.serviceOfferings = serviceOfferingsArrUpdated;
        state.serviceOfferingTotalCount = state.changedPriceSheet
          ?.serviceOfferings
          ? state.changedPriceSheet.serviceOfferings?.length
          : 0;
      } else {
        state.isDuplicateServiceOfferings = true;
      }

      if (state.isDeferralPriceSheet) {
        state.isUpdatedDeferralSheet = true;
      }

      if (state.isLogisticFeesSheet) {
        state.isUpdatedLogisticSheet = true;
      }
    },
    handleResetDeferralValue: (state) => {
      state.changedPriceSheet.priceClasses =
        initialState.changedPriceSheet.priceClasses;
      state.changedPriceSheet.notes = initialState.changedPriceSheet.notes;
      state.changedPriceSheet.serviceOfferings =
        initialState.changedPriceSheet.serviceOfferings;
      state.originalPriceSheet.serviceOfferings =
        initialState.originalPriceSheet.serviceOfferings;
      state.priceSheetDataById = initialState.priceSheetDataById;
      state.notesData.comment = initialState.notesData.comment;
      state.apiSuccessResponse.update = initialState.apiSuccessResponse.update;
      state.duplicatePriceSheetObj = initialState.duplicatePriceSheetObj;
      state.priceSheetAuditTrailData = initialState.priceSheetAuditTrailData;
      state.priceClassesTotalCount = initialState.priceClassesTotalCount;
      state.priceSheetExistTotalCount = initialState.priceSheetExistTotalCount;
      state.priceSheetSelectedData = initialState.priceSheetSelectedData;
      state.pricesData = initialState.pricesData;
      state.priceSheetData = initialState.priceSheetData;
      state.priceSheetNotesData = initialState.priceSheetNotesData;
      state.priceSheetAuditTrailData = initialState.priceSheetAuditTrailData;
      state.changedPriceSheet.priceSheet =
        initialState.changedPriceSheet.priceSheet;
      state.isUpdatedDeferralSheet = initialState.isUpdatedDeferralSheet;
      state.saveReason = initialState.saveReason;
      state.priceClassSelectBYId = initialState.priceClassSelectBYId;
    },
    handleResetLogisticsValue: (state) => {
      state.changedPriceSheet.priceClasses =
        initialState.changedPriceSheet.priceClasses;
      state.changedPriceSheet.notes = initialState.changedPriceSheet.notes;
      state.changedPriceSheet.serviceOfferings =
        initialState.changedPriceSheet.serviceOfferings;
      state.originalPriceSheet.serviceOfferings =
        initialState.originalPriceSheet.serviceOfferings;
      state.priceSheetDataById = initialState.priceSheetDataById;
      state.notesData.comment = initialState.notesData.comment;
      state.apiSuccessResponse.update = initialState.apiSuccessResponse.update;
      state.duplicatePriceSheetObj = initialState.duplicatePriceSheetObj;
      state.priceSheetAuditTrailData = initialState.priceSheetAuditTrailData;
      state.serviceOfferingTotalCount = initialState.serviceOfferingTotalCount;
      state.priceClassSelectBYId = initialState.priceClassSelectBYId;
      state.logisticFeeData = initialState.logisticFeeData;
      state.priceSheetExistTotalCount = initialState.priceSheetExistTotalCount;
      state.priceSheetSelectedData = initialState.priceSheetSelectedData;
      state.pricesData = initialState.pricesData;
      state.priceSheetNotesData = initialState.priceSheetNotesData;
      state.priceSheetAuditTrailData = initialState.priceSheetAuditTrailData;
      state.changedPriceSheet.priceSheet =
        initialState.changedPriceSheet.priceSheet;
      state.isUpdatedLogisticSheet = initialState.isUpdatedLogisticSheet;
      state.saveReason = initialState.saveReason;
    },
    handlePriceClassRadio: (state, action) => {
      state.priceClassRadio = action?.payload ? action?.payload : '';
    },
    handlePriceClassModel: (state, action) => {
      state.isSearchPriceModalOpen = action?.payload ? action?.payload : false;
    },
    handleServiceOfferingModel: (state, action) => {
      state.isSearchServiceModalOpen = action?.payload
        ? action?.payload
        : false;
    },
    handleCreatePriceSheet: (state) => {
      let effectiveDate = state.priceSheetForm?.effectiveDate;
      effectiveDate = formatEffectiveDateTime(effectiveDate);

      state.changedPriceSheet.notes = initialState.changedPriceSheet.notes;

      const newPriceSheetData = {
        pricing_Id: -1,
        pricingTypeId: state.priceSheetForm?.pricingTypeId,
        countryId: state.priceSheetForm?.countryId,
        countryName: state.priceSheetForm?.countryName,
        currencyId: state.usCurrencyId, //hardcoded - taking from IinitialState
        accountingGroupCode:
          state.priceSheetForm?.accountingGroup.length !== 0
            ? state.priceSheetForm?.accountingGroup
            : null,
        accountGroupName: state.priceSheetForm?.accountGroupName
          ? state.priceSheetForm?.accountGroupName
          : null,
        description: '',
        effectiveDate: effectiveDate,
        consumableFee:
          state.priceSheetForm?.pricingTypeId ===
            PRICING_DATA.pricingTypeId.StandardLogistics
            ? state.logisticFeeData.consumableFee
            : 0,
        percentMargin:
          state.priceSheetForm.pricingTypeId ===
            PRICING_DATA.pricingTypeId.StandardLogistics
            ? state.logisticFeeData?.percentMargin
            : 0,
        activeFlag: state.priceSheetForm?.activeFlag,
        firstModifiedTimestamp: state.priceSheetForm?.effectiveDate,
        lastModifiedTimestamp: state.priceSheetForm?.effectiveDate,
      };
      state.changedPriceSheet.priceSheet = newPriceSheetData;
      if (state.isDeferralPriceSheet) {
        state.originalPriceSheet.priceClasses = [];
        state.priceClassesTotalCount = initialState.priceClassesTotalCount;
        state.pricesData = initialState.pricesData;
      }
      if (state.isLogisticFeesSheet) {
        state.serviceOfferingTotalCount =
          initialState.serviceOfferingTotalCount;
      }
    },
    handleUpdateDuplicatePriceSheet: (state, action) => {
      state.duplicatePriceSheetObj = action?.payload;
    },
    handleUpdatedSeriveOfferingInChangedPriceSheet: (state, action) => {
      state.changedPriceSheet.serviceOfferings = [];
      state.changedPriceSheet.serviceOfferings = action?.payload;
      state.serviceOfferingTotalCount = state.changedPriceSheet
        ?.serviceOfferings
        ? state.changedPriceSheet?.serviceOfferings?.length
        : 0;
    },
    handleClikedRowIndex: (state, action) => {
      state.isClickedRowIndex = action?.payload;
    },
    handleSaveClose: (state, action) => {
      state.saveAndClosePriceSheet = action?.payload;
    },
    handleResetServiceOffering: (state) => {
      state.searchServiceOffer.serviceName =
        initialState.searchServiceOffer.serviceName;
    },
    handleAnuualFeeService: (state, action) => {
      state.calculatedFees = action?.payload;
    },
    setOpenAlertBoxExist: (state) => {
      state.alertDialogExist = true;
    },
    setCloseAlertBoxExist: (state) => {
      state.alertDialogExist = false;
    },
    handleVisibilityCopyPriceSheetBtn: (state, action) => {
      state.isCopyPriceSheetBtnVisible = action?.payload;
    },
    setCopyPriceSheetAccountingGroupModalOpen: (state) => {
      state.openCopyPriceSheetAccountingModal = true;
      state.accoutingGroupSearchForm.accountGroupName = '';
    },
    setCopyPriceSheetAccountingGroupModalClose: (state) => {
      state.openCopyPriceSheetAccountingModal = false;
      state.accoutingGroupCopyPriceSheetSearchForm.accountGroupName = '';
      state.accoutingGroupCopyPriceSheetSearchForm.isActive =
        CHECK_BOX_VALUE.no;
      state.accoutingGroupCopyPriceSheetSearchForm.isResellerGroup =
        CHECK_BOX_VALUE.no;
      state.accountingGroupCopyPriceSheetFilteredData = [];
    },
    setOpenCopyPriceSheetCountryModal: (state) => {
      state.openCopyPriceSheetCountryModal = true;
      state.countryCopyPriceSheetSearchForm.name = '';
      state.countryCopyPriceSheetSearchForm.countryCode = '';
      state.countrySearchForm.name = '';
      state.countrySearchForm.countryCode = '';
    },
    setCloseCopyPriceSheetCountryModal: (state) => {
      state.openCopyPriceSheetCountryModal = false;
      state.countryCopyPriceSheetSearchForm.name = '';
      state.countryCopyPriceSheetSearchForm.countryCode = '';
      state.countrySearchForm.name = '';
      state.countrySearchForm.countryCode = '';
    },
    setCopyPriceSheetModalOpen: (state) => {
      state.openCopyPriceSheetModal = true;
      state.copypriceSheetForm = initialState.copypriceSheetForm;
      state.apiSuccessResponse.copyPriceSheet = '';
      state.isCopyPriceSheetSaveResults = '';
    },
    setCopyPriceSheetModalClose: (state) => {
      state.openCopyPriceSheetModal = false;
      state.apiSuccessResponse.copyPriceSheet = '';
    },
    handleCopyPriceSheetSourceData: (state) => {
      state.sourcePriceSheet = state.changedPriceSheet?.priceSheet || {};
    },
    handleLogisticsCalculatedFees: (state) => {
      state.changedPriceSheet.serviceOfferings.map((serviceOffering) => {
        serviceOffering.calculatedFees = evalcalculatedFees(
          serviceOffering.annualFee,
          state.logisticFeeData.percentMargin
        );
      });
    },
    handleIsUpdatedDeferralSheet: (state, action) => {
      state.isUpdatedDeferralSheet =
        action?.payload || initialState.isDeferralPriceSheet;
    },
    handleIsUpdatedLogisticSheet: (state, action) => {
      state.isUpdatedLogisticSheet =
        action?.payload || initialState.isUpdatedLogisticSheet;
    },
    handleSaveReason: (state, action) => {
      state.saveReason = action?.payload || initialState.saveReason;
    },
    resetIsDuplicatePriceClass: (state) => {
      state.isDuplicatePriceClasses = false;
    },
    resetIsDuplicateServiceOffering: (state) => {
      state.isDuplicateServiceOfferings = false;
    },
    resetLogisticPriceSheetServiceOfferings: (state, action) => {
      state.duplicatePriceSheetObj = action?.payload || [];
    },
    resetPriceSheetHeaderData: (state) => {
      if (state.isDeferralPriceSheet) {
        state.changedPriceSheet.priceSheet['activeFlag'] =
          state.originalPriceSheet.priceSheet['activeFlag'];
      }

      if (state.isLogisticFeesSheet) {
        state.changedPriceSheet.priceSheet['activeFlag'] =
          state.originalPriceSheet.priceSheet['activeFlag'];
        state.changedPriceSheet.priceSheet['consumableFee'] =
          state.originalPriceSheet?.priceSheet['consumableFee'] || '';
        state.changedPriceSheet.priceSheet['percentMargin'] =
          state.originalPriceSheet?.priceSheet['percentMargin'] || '';
        state.logisticFeeData['consumableFee'] =
          state.originalPriceSheet?.priceSheet['consumableFee'] || '';
        state.logisticFeeData['percentMargin'] =
          state.originalPriceSheet?.priceSheet['percentMargin'] || '';
      }

      state.changedPriceSheet.notes = initialState.changedPriceSheet.notes;
      state.changedPriceSheet.notes = JSON.parse(
        JSON.stringify(state.originalPriceSheet.notes)
      );

      state.isEditNotes = false;
      state.notesData.comment = '';
    },
    handleBackPriceSheet: (state, action) => {
      state.backPriceSheet = action?.payload;
    },
    handlePriceSheetFlag: (state, action) => {
      state.getPriceSheetFlag = action?.payload;
    },
    handleEditClickedNotes: (state) => {
      state.isEditClick = true;
      state.isEditNotes = true;
    },
    resetapiSuccessAction: (state, action) => {
      state.apiSuccessResponse = initialState.apiSuccessResponse;
    },
    handleResetServiceOfferings: (state) => {
      state.changedPriceSheet.serviceOfferings =
        initialState.changedPriceSheet.serviceOfferings;
      state.originalPriceSheet.serviceOfferings =
        initialState.originalPriceSheet.serviceOfferings;
    },
    handleSearchedPriceClassName: (state, action) => {
      state.searchedPriceClassName = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountingGroupsData.pending, handlePending)
      .addCase(fetchAccountingGroupsData.fulfilled, (state, action) => {
        state.loading = false;
        state.accountingGroups = action?.payload ? action?.payload : [];
      })
      .addCase(fetchAccountingGroupsData.rejected, handleRejection)

      .addCase(fetchCountriesData.pending, handlePending)
      .addCase(fetchCountriesData.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action?.payload ? action?.payload : [];
      })
      .addCase(fetchCountriesData.rejected, handleRejection)

      .addCase(fetchPriceTypesData.pending, handlePending)
      .addCase(fetchPriceTypesData.fulfilled, (state, action) => {
        state.loading = false;
        state.priceTypes = action?.payload ? action?.payload : [];
      })
      .addCase(fetchPriceTypesData.rejected, handleRejection)

      .addCase(accountingGroupSearchData.pending, (state) => {
        state.accountingGroupFilteredData = [];
        state.isAccountingGroupsResults = null;
      })
      .addCase(accountingGroupSearchData.fulfilled, (state, action) => {
        state.loading = false;
        state.accountingGroupFilteredData = action?.payload
          ? action?.payload?.accountingGroups
          : [];
        state.accountingTotalCount = action?.payload?.totalCount
          ? action?.payload?.totalCount
          : 0;
        state.isAccountingGroupsResults =
          action?.payload?.accountingGroups?.length === 0;
      })

      .addCase(accountingGroupSearchData.rejected, (state, action) => {
        handleRejection(state, action);
        state.accountingGroupFilteredData = [];
        state.accountingTotalCount = 0;
        state.isAccountingGroupsResults = true;
      })

      .addCase(countriesSearchData.pending, (state) => {
        state.countryFilteredData = [];
        state.isCountryResults = null;
      })
      .addCase(countriesSearchData.fulfilled, (state, action) => {
        state.loading = false;
        state.countryFilteredData = action?.payload
          ? action?.payload?.country
          : [];
        state.countryTotalCount = action?.payload?.totalCount
          ? action?.payload?.totalCount
          : 0;
        state.isCountryResults = action?.payload?.country?.length === 0;
      })

      .addCase(countriesSearchData.rejected, (state, action) => {
        handleRejection(state, action);
        state.countryFilteredData = [];
        state.countryTotalCount = 0;
        state.isCountryResults = true;
      })

      .addCase(fetchPriceSheetSearchCount.pending, (state, action) => {
        handlePending(state, action);
        state.priceSheetExistTotalCount = 0;
        state.gridAccountingRowSelectedData =
          initialState.gridAccountingRowSelectedData;
        state.changedPriceSheet.consumableFee =
          initialState.changedPriceSheet.consumableFee;
        state.changedPriceSheet.percentMargin =
          initialState.changedPriceSheet.percentMargin;
        state.logisticFeeData = initialState.logisticFeeData;
      })
      .addCase(fetchPriceSheetSearchCount.fulfilled, (state, action) => {
        state.loading = false;
        if (state.openCopyPriceSheetModal === true) {
          if (action?.payload?.length > 0) {
            state.priceSheetExistTotalCount =
              action?.payload[0]?.totalRecords >= 1 ? 1 : 0;
            state.destinationPriceSheetData = action?.payload[0] || [];
          }
        }

        if (
          state.priceSheetData?.length >= 0 &&
          state.openCopyPriceSheetModal === false
        ) {
          if (action?.payload?.length > 0) {
            state.priceSheetExistTotalCount =
              action?.payload[0]?.totalRecords >= 1 ? 1 : 0;
          }

          if (
            state.priceSheetExistTotalCount >= 1 &&
            state.priceSheetData?.length === 0 &&
            !state.priceSheetSelectedData?.priceSheetId > 0
          ) {
            //If PriceSheet Already Exist Bind the Data to display the values
            state.gridAccountingRowSelectedData = action?.payload[0]
              ? action?.payload[0]
              : [];
            const data = action?.payload[0] ? action?.payload[0] : [];

            state.priceSheetSelectedData.priceSheetId = data?.priceSheetId;
            state.priceSheetSelectedData.countryId = data?.countryId;
            state.priceSheetSelectedData.accountingGroupCode =
              data?.accountingGroupCode;
            state.priceSheetSelectedData.countryCode = data?.countryCode;
            state.priceSheetSelectedData.accountingGroupName =
              data?.accountingGroupName;
            state.priceSheetSelectedData.countryName = data?.countryName;
            state.priceSheetSelectedData.pricingTypeId = data?.pricingTypeId;
            state.priceSheetSelectedData.pricingType = data?.pricingType;
            state.priceSheetSelectedData.activeFlag = data?.activeFlag;
            state.priceSheetSelectedData.effectiveDate = data?.effectiveDate
              ? new Date(data.effectiveDate)
              : new Date();
            state.priceSheetSelectedData.createdBy = data?.createdBy;
            state.priceSheetSelectedData.createdOn = data?.createdOn;
          }
        }
      })
      .addCase(fetchPriceSheetSearchCount.rejected, (state, action) => {
        handleRejection(state, action);
        state.priceSheetExistTotalCount = 0;
        state.gridAccountingRowSelectedData =
          initialState.gridAccountingRowSelectedData;
        state.changedPriceSheet.consumableFee =
          initialState.changedPriceSheet.consumableFee;
        state.changedPriceSheet.percentMargin =
          initialState.changedPriceSheet.percentMargin;
        state.logisticFeeData = initialState.logisticFeeData;
      })

      .addCase(priceSheetSearchData.pending, (state) => {
        state.priceSheeetSearchDataLoading = true;
        state.priceSheetData = [];
        state.isPriceSheetResults = null;
      })
      .addCase(priceSheetSearchData.fulfilled, (state, action) => {
        state.loading = false;
        state.priceSheeetSearchDataLoading = false;
        state.priceSheetData = action?.payload ? action?.payload : [];
        if (action?.payload) {
          state.priceSheetSelectedData = initialState.priceSheetSelectedData;
        }
        state.priceSheetTotalCount = action?.payload
          ? action?.payload[0].totalRecords
          : 0;
        state.isPriceSheetResults = action?.payload?.length === 0;
      })

      .addCase(priceSheetSearchData.rejected, (state, action) => {
        handleRejection(state, action);
        state.priceSheeetSearchDataLoading = false;
        state.priceSheetData = [];
        state.priceSheetTotalCount = 0;
        state.isPriceSheetResults = true;
      })

      .addCase(priceSheetGetData.pending, handlePending)
      .addCase(priceSheetGetData.fulfilled, (state, action) => {
        state.loading = false;
        if (state.priceSheetExistTotalCount >= 1) {
          state.destinationPriceSheet = action?.payload[0] || [];
        }

        state.priceSheetDataById = action?.payload ? action?.payload : {};
        state.originalPriceSheet.priceSheet = action?.payload
          ? action?.payload
          : {};
        state.changedPriceSheet.priceSheet = action?.payload
          ? action?.payload
          : {};
        state.logisticFeeData.consumableFee = action?.payload?.consumableFee
          ? action?.payload?.consumableFee
          : 0;
        state.logisticFeeData.percentMargin = action?.payload?.percentMargin
          ? action?.payload?.percentMargin
          : 0;
      })
      .addCase(priceSheetGetData.rejected, handleRejection)

      .addCase(fetchPricesGetData.pending, (state, action) => {
        handlePending(state, action);
        state.isPricesGetData = initialState.isPricesGetData;
      })
      .addCase(fetchPricesGetData.fulfilled, (state, action) => {
        state.loading = false;
        if (state.getPriceSheetFlag) {
          state.isPricesGetData =
            action?.payload &&
            action?.payload?.priceClasses.length > 0 &&
            action?.payload?.priceClasses.find(
              (item) => item.name === state.searchedPriceClassName
            ) ? true : false;
        } else {
          let data = action?.payload ? action?.payload : [];
          if (state.isLogisticFeesSheet) {
            const logisticFilterData = data?.priceClasses?.filter(
              (priceClass) => {
                return (
                  priceClass.price_Class_Id ===
                  PRICING_DATA.logistcsPriceSheetPriceClassId
                );
              }
            );

            data.priceClasses = logisticFilterData || [];
          }

          state.pricesData = data || [];
          const pricingId = state.priceSheetDataById?.pricing_Id
            ? state.priceSheetDataById?.pricing_Id
            : initialState.priceSheetDataById.pricing_Id;
          const customizedObj = data?.priceClasses?.map((priceClass, idx) => {
            // Assuming priceClass is an object with properties similar to priceClasses
            return {
              id: idx + 1,
              pricing_Id: pricingId,
              priceClassId: priceClass.price_Class_Id,
              priceClassName: priceClass.name,
              lastModifiedUserId: priceClass.last_Modified_User_Id,
              lastModifiedTimestamp: priceClass.last_Modified_TimeStamp,
              // Add additional properties if needed
            };
          });

          state.priceClassesTotalCount = data?.priceClasses?.length
            ? data.priceClasses.length
            : 0;
          state.isPriceClassesResults = data?.priceClasses?.length === 0;

          state.originalPriceSheet.priceClasses = customizedObj;
          state.changedPriceSheet.priceClasses = customizedObj;
          state.duplicatePriceSheetObj = customizedObj;
        }
      })
      .addCase(fetchPricesGetData.rejected, (state, action) => {
        handleRejection(state, action);
        state.isPricesGetData = initialState.isPricesGetData;
      })

      .addCase(pricesGetData.pending, (state) => {
        state.changedPriceSheet.priceClasses = [];
        state.isPriceClassesResults = null;
        state.pricesData = initialState.pricesData;
      })
      .addCase(pricesGetData.fulfilled, (state, action) => {
        state.loading = false;
        let data = action?.payload ? action?.payload : [];
        if (state.isLogisticFeesSheet) {
          const logisticFilterData = data?.priceClasses?.filter(
            (priceClass) => {
              return (
                priceClass.price_Class_Id ===
                PRICING_DATA.logistcsPriceSheetPriceClassId
              );
            }
          );

          data.priceClasses = logisticFilterData || [];
        }

        state.pricesData = data || [];
        const pricingId = state.priceSheetDataById?.pricing_Id
          ? state.priceSheetDataById?.pricing_Id
          : initialState.priceSheetDataById.pricing_Id;
        const customizedObj = data?.priceClasses?.map((priceClass, idx) => {
          // Assuming priceClass is an object with properties similar to priceClasses
          return {
            id: idx + 1,
            pricing_Id: pricingId,
            priceClassId: priceClass.price_Class_Id,
            priceClassName: priceClass.name,
            lastModifiedUserId: priceClass.last_Modified_User_Id,
            lastModifiedTimestamp: priceClass.last_Modified_TimeStamp,
            // Add additional properties if needed
          };
        });

        state.priceClassesTotalCount = data?.totalCount ? data.totalCount : 0;
        state.isPriceClassesResults = data?.priceClasses?.length === 0;

        state.originalPriceSheet.priceClasses = customizedObj;
        state.changedPriceSheet.priceClasses = customizedObj;
        state.duplicatePriceSheetObj = customizedObj;
      })
      .addCase(pricesGetData.rejected, (state, action) => {
        handleRejection(state, action);
        state.changedPriceSheet.priceClasses = [];
        state.originalPriceSheet.priceClasses = [];
        state.duplicatePriceSheetObj = [];
        state.priceClassesTotalCount = 0;
        state.isPriceClassesResults = true;
      })

      .addCase(priceSheetNotesData.pending, handlePending)
      .addCase(priceSheetNotesData.fulfilled, (state, action) => {
        state.loading = false;
        state.priceSheetNotesData = action?.payload ? action?.payload : [];
        state.changedPriceSheet.notes = action?.payload ? action?.payload : [];
        state.originalPriceSheet.notes = action?.payload ? action?.payload : [];
      })
      .addCase(priceSheetNotesData.rejected, handleRejection)

      .addCase(priceSheetAuditTrailData.pending, handlePending)
      .addCase(priceSheetAuditTrailData.fulfilled, (state, action) => {
        state.loading = false;
        state.priceSheetAuditTrailData = action?.payload ? action?.payload : [];
      })
      .addCase(priceSheetAuditTrailData.rejected, handleRejection)

      .addCase(fetchPriceClassServiceOfferings.pending, handlePending)
      .addCase(fetchPriceClassServiceOfferings.fulfilled, (state, action) => {
        state.loading = false;
        const data = action?.payload[0] ? action?.payload[0] : [];

        if (state.isLogisticFeesSheet) {
          state.serviceOfferingTotalCount =
            action?.payload?.length > 0 ? action?.payload?.length : 0;
          if (action?.payload?.length === 1) {
            let calculatedFees = parseFloat(
              evalcalculatedFees(
                data?.annualFee || 0,
                state.logisticFeeData?.percentMargin
              )
            ).toFixed(2);
            action.payload[0][state.calculatedFeesField] = calculatedFees || 0;
          } else if (action?.payload?.length >= 1) {
            action?.payload?.forEach((obj) => {
              let calculatedFees = parseFloat(
                evalcalculatedFees(
                  obj?.annualFee || 0,
                  state.logisticFeeData?.percentMargin
                )
              ).toFixed(2);
              obj[state.calculatedFeesField] = calculatedFees || 0;
            });
          }
        }

        const checkExistServiceOfferings =
          state.duplicatePriceSheetObj !== undefined
            ? JSON.parse(JSON.stringify(state.duplicatePriceSheetObj))
            : [];
        let elementIndex = -1;
        if (state.isDeferralPriceSheet) {
          checkExistServiceOfferings?.forEach((item, index) => {
            if (
              item.priceClassId === data?.priceClassId &&
              JSON.parse(JSON.stringify(item))?.serviceOfferings ===
              undefined &&
              JSON.parse(
                JSON.stringify(state.changedPriceSheet?.serviceOfferings)
              )?.[index] === undefined
            ) {
              elementIndex = index;
            }
          });
        }

        // merge and override the serviceOfferings, removes duplicate data.
        const mergeAndOverrideServiceOffereings = (existing, newData) => {
          const existingKeys = new Set(
            existing.map(
              (item) =>
                `${item.priceClassId}-${item.pricingId}-${item.servicePriceLevelId}`
            )
          );

          return [
            ...existing,
            ...newData.filter(
              (item) =>
                !existingKeys.has(
                  `${item.priceClassId}-${item.pricingId}-${item.servicePriceLevelId}`
                )
            ),
          ];
        };

        if (elementIndex > -1) {
          const changedPriceSheetUpdatedData = updateObjectInArray(
            state.duplicatePriceSheetObj,
            'priceClassId',
            data?.priceClassId,
            'serviceOfferings',
            action?.payload
          );

          state.duplicatePriceSheetObj = changedPriceSheetUpdatedData;
          state.originalPriceSheet.serviceOfferings = [
            ...JSON.parse(
              JSON.stringify(state.originalPriceSheet.serviceOfferings)
            ),
            ...action?.payload,
          ];
          state.changedPriceSheet.serviceOfferings = [
            ...JSON.parse(
              JSON.stringify(state.changedPriceSheet.serviceOfferings)
            ),
            ...action?.payload,
          ];
        } else if (elementIndex === -1) {
          let changedPriceSheetUpdatedData = [];
          changedPriceSheetUpdatedData = updateObjectInArray(
            state.duplicatePriceSheetObj,
            'priceClassId',
            data?.priceClassId,
            'serviceOfferings',
            action?.payload
          );

          state.duplicatePriceSheetObj = changedPriceSheetUpdatedData;
          if (state.isDeferralPriceSheet) {
            state.originalPriceSheet.serviceOfferings =
              mergeAndOverrideServiceOffereings(
                state.originalPriceSheet.serviceOfferings,
                action?.payload
              );
            state.changedPriceSheet.serviceOfferings =
              mergeAndOverrideServiceOffereings(
                state.changedPriceSheet.serviceOfferings,
                action?.payload
              );
          } else {
            state.originalPriceSheet.serviceOfferings = [...action?.payload];
            state.changedPriceSheet.serviceOfferings = [...action?.payload];
          }
        } else {
          if (state.isLogisticFeesSheet) {
            state.serviceOfferingTotalCount =
              checkExistServiceOfferings[
                elementIndex
              ]?.serviceOfferings?.length;
          }
        }
      })
      .addCase(fetchPriceClassServiceOfferings.rejected, handleRejection)

      .addCase(priceSheetSaveData.pending, (state) => {
        state.isPriceSheetSaveResults = true;
      })
      .addCase(priceSheetSaveData.fulfilled, (state, action) => {
        state.loading = false;

        if (state.isLogisticFeesSheet) {
          state.serviceOfferingTotalCount =
            action?.payload?.serviceOfferings?.length || 0;

          if (action?.payload?.serviceOfferings.length === 1) {
            let calculatedFees = parseFloat(
              evalcalculatedFees(
                action.payload.serviceOfferings[0].annualFee || 0,
                state.logisticFeeData.percentMargin
              )
            ).toFixed(2);
            action.payload.serviceOfferings[0][state.calculatedFeesField] =
              calculatedFees || 0;
          } else if (action?.payload?.serviceOfferings.length >= 1) {
            action.payload?.serviceOfferings.forEach((obj) => {
              let calculatedFees = parseFloat(
                evalcalculatedFees(
                  obj?.annualFee || 0,
                  state.logisticFeeData?.percentMargin
                )
              ).toFixed(2);
              obj[state.calculatedFeesField] = calculatedFees || 0;
            });
          }
        }
        state.priceSheetSave = action?.payload;
        state.originalPriceSheet = action?.payload;
        state.changedPriceSheet = action?.payload;
        state.priceSheetAuditTrailData = [...state.priceSheetAuditTrailData];
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          update: true,
        };
        state.isPriceSheetSaveResults = false;
        if (state.isDeferralPriceSheet) {
          state.priceClassSelectBYId = initialState?.priceClassSelectBYId;
          state.originalPriceSheet.serviceOfferings =
            initialState.originalPriceSheet.serviceOfferings;
          state.changedPriceSheet.serviceOfferings =
            initialState.changedPriceSheet.serviceOfferings;
        }
      })

      .addCase(priceSheetSaveData.rejected, (state, action) => {
        handleRejection(state, action);
        state.isPriceSheetSaveResults = false;
      })

      .addCase(copypriceSheetSaveData.pending, (state) => {
        state.isCopyPriceSheetSaveResults = false;
        state.loading = true;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          copyPriceSheet: '',
        };
      })
      .addCase(copypriceSheetSaveData.fulfilled, (state) => {
        state.loading = false;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          copyPriceSheet: 'success',
        };
        state.isCopyPriceSheetSaveResults = true;
      })

      .addCase(copypriceSheetSaveData.rejected, (state, action) => {
        handleRejection(state, action);
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          copyPriceSheet: 'error',
        };
        state.isCopyPriceSheetSaveResults = false;
        state.loading = false;
      });
  },
});

export const {
  handleActiveFlag,
  setSearchTerm,
  setPriceSheetFormFields,
  setDeferralAddNotes,
  setLogisticAddNotes,
  setLogisticFee,
  setActiveFlag,
  setSelectedCountryGridRowsData,
  setSelectedAccountGridRowsData,
  setAccountingGroupModalOpen,
  setAccountingGroupModalClose,
  setOpenCountryModal,
  setCloseCountryModal,
  setAccouningGroupFormFeilds,
  setCountryFormFeilds,
  setOpenAlertBox,
  setCloseAlertBox,
  handleFilteredCoutryData,
  handleFilteredAccountingGroupData,
  handleSelectedTab,
  handleShowDeferralPriceSheet,
  handleShowLogisticPriceSheet,
  handleCloseDeferralPriceSheet,
  handleCloseLogisticPriceSheet,
  handleSelectedDate,
  handleResetValue,
  handlePriceSheetAlert,
  handleSelectedPrisheetGrid,
  handlePriceClassSearch,
  handleResetPriceClassForm,
  handleModalClose,
  handleModalOpen,
  handleNotesSlectedGrid,
  handleEditNotesData,
  handleAddNewNotes,
  handleAddNewNotesSave,
  handlePriceClassSelectedGrid,
  handlePriceClassAdd,
  handleServiceOfferingSearch,
  handleServiceOfferReset,
  handleDeletePriceClasses,
  handlePriceClassSelectById,
  handleSelectedServiceOfferGrid,
  handleServiceOfferingAdd,
  handleResetDeferralValue,
  handleResetLogisticsValue,
  handlePriceClassRadio,
  handlePriceClassModel,
  handleServiceOfferingModel,
  handleUpdateDuplicatePriceSheet,
  handleUpdatedSeriveOfferingInChangedPriceSheet,
  handleClikedRowIndex,
  handleCreatePriceSheet,
  handleSaveClose,
  handleResetServiceOffering,
  handleAnuualFeeService,
  setOpenAlertBoxExist,
  setCloseAlertBoxExist,
  handleVisibilityCopyPriceSheetBtn,
  setCopyPriceSheetAccountingGroupModalOpen,
  setCopyPriceSheetAccountingGroupModalClose,
  setOpenCopyPriceSheetCountryModal,
  setCloseCopyPriceSheetCountryModal,
  setCopyPriceSheetModalOpen,
  setCopyPriceSheetModalClose,
  setOpenAlertBoxDuplicateCountry,
  setCloseAlertBoxDuplicateCountry,
  handleCopyPriceSheetSourceData,
  setCloseAlertBoxCopyExist,
  setOpenAlertBoxCopyExist,
  cleatPriceSheetSelectedData,
  handleLogisticsCalculatedFees,
  handleIsUpdatedDeferralSheet,
  handleIsUpdatedLogisticSheet,
  handleSaveReason,
  resetIsDuplicateServiceOffering,
  resetIsDuplicatePriceClass,
  resetLogisticPriceSheetServiceOfferings,
  resetPriceSheetHeaderData,
  handleBackPriceSheet,
  handlePriceSheetFlag,
  handleResetNotes,
  handleEditClickedNotes,
  resetapiSuccessAction,
  handleResetServiceOfferings,
  handleSearchedPriceClassName,
} = priceSheetSlice.actions;

export default priceSheetSlice.reducer;
